import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { acknowledgeFailedJobs } from "@/app/actions/user/acknowledge-failed-jobs/action";
import { getRecentFailedJobs } from "@/app/actions/user/get-failed-jobs/action";
import { ModalStore } from "@/app/stores/ModalStore";
import { UserStore } from "@/app/stores/UserStore";
import { PageParams } from "@/app/types/common/DefaultProps";
import { Globals } from "@/app/vars/Globals";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useNotifyFailedJobs(params: PageParams): void {
  const user = UserStore((state) => state.user);
  const acknowledgedRef = useRef(false);

  // A failure toast can arrive a moment late; hold this background read out of the initial
  // serialized Server Action burst so the page's critical data (the tool workspace) is not
  // stuck behind it in the queue.
  const [deferred, setDeferred] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setDeferred(true), Globals.FAILED_JOBS_DEFER_MS);
    return () => clearTimeout(timer);
  }, []);

  const { data } = useQuery({
    queryKey: [QueryKey.FAILED_JOBS],
    queryFn: () => getRecentFailedJobs(),
    enabled: !!user && deferred,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (!data || data.length === 0 || acknowledgedRef.current) return;

    acknowledgedRef.current = true;
    ModalStore.getState().openJobFailure(params, data);
    acknowledgeFailedJobs(data.map((job) => job.id));
  }, [data, params]);
}
